import React from 'react';
import { Link } from 'react-router-dom';
import Practices from '../../api/Practices';


const Practice = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (

        <section className={`service-section ${props.sClass}`}>
            <div className="content-area clearfix">
                <div className="left-col">
                    <div className="inner-content">
                        <blockquote>“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.”</blockquote>

                        <h4>Michel Schiff</h4>
                        <span>Co-Founder</span>
                    </div>
                </div>
                <div className="right-col">
                    <div className="section-title-s2">
                        <div className="icon">
                            <i className="fi flaticon-balance"></i>
                        </div>
                        <span>we can help you</span>
                        <h2>Areas We Practice</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div className="service-grids clearfix">
                        {Practices.map((practice, Pitem) => (
                            <div className="grid" key={Pitem}>
                                <i className={`fi ${practice.sIcon}`}></i>
                                <h3><Link onClick={ClickHandler} to={`/`}>{practice.sTitle}</Link></h3>
                                <p>{practice.des2}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Practice;